"use strict";
import { jsx } from "react/jsx-runtime";
import HoverableValue from "../hoverable_value";
export default function ValueTableItem(props) {
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
    HoverableValue,
    {
      value: props.value,
      onValueHighlighted: props.onValueHighlighted,
      onValueClick: props.onValueClick
    }
  ) });
}
